import { useEffect } from 'react';
import { useSessionStorage } from 'react-use';

import { useWizard } from '@portals/framework';

import { SignupWizardContextDataType, StepIdEnum } from './wizard.types';

export function useSignUpWizard() {
  return useWizard<SignupWizardContextDataType, StepIdEnum>();
}

export function useClassificationSessionStorage() {
  const [
    classificationSessionStorageValue,
    setClassificationSessionStorageValue,
  ] =
    useSessionStorage<SignupWizardContextDataType['classification']>(
      'customer'
    );

  useEffect(() => {
    setClassificationSessionStorageValue('customer');
  }, [setClassificationSessionStorageValue]);

  const removeClassificationSessionStorageValue = () => {
    sessionStorage.removeItem('customer');
  };

  return {
    classificationSessionStorageValue,
    setClassificationSessionStorageValue,
    removeClassificationSessionStorageValue,
  };
}
